// (function () {
//     'use strict';
//
//     angular
//         .module('estadisticas')
//         .directive('filtros', FiltrosGraficoDirective);


    FiltrosGraficoDirective.$inject = [];
    export default function FiltrosGraficoDirective() {
        return {
            restrict: 'E',
            scope: {
                grafico: '=',
                onChange: '&'
            },
            template: require('./graficos-filtros.html'),
            controller: 'FiltrosGraficoCtrl',
            controllerAs: 'vm',
            bindToController: true
        }
    }

// })();